import { Alert, Box, DialogContent, DialogContentText, FormControlLabel, Radio, RadioGroup, Typography } from "@mui/material";
import PageTitle from "../../../components/pageTitle/PageTitle";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import {
  deleteRoleAction,
  getAllRoles,
  reassignRoleAction,
  setAddRoleResponse,
  setDeleteRoleResponse,
  setReassignRoleResponse,
  updateRoleResponse,
} from "../../../store/reducers/roleSlice";
import PermissionsTable from "./PermissionTable";
import ManageRole from "./ManageRole";
import { setNotificationAction } from "../../../store/reducers/mmymSlice";
import Popup from "../../../components/common/model/Popup";
import useStyles from "../../../components/common/model/styles";
import closeIcon from "../../../assets/closeModel.png";
import CustomButton from "../../../components/common/button/CustomButton";
import Notification from "../../../components/common/notification/Notification";

const RoleDetails = () => {
  const [open, setOpen] = useState(false); // State variable to manage dialog open/close
  const [selectedRole, setSelectedRole] = useState("");
  const [title, setTitle] = useState("");
  const [deleteModelShow, setDeleteModelShow] = useState(false);
  const [deleteRoleData, setDeleteRoleData] = useState<any>(null);
  const [reassignRoleId, setReassignRoleId] = useState<string>("");
  const classes = useStyles();

  const dispatch = useDispatch();

  const { roles, isAddRoleSuccess, isRoleResponse, isDeleteRoleSuccess, isReassignRoleSuccess } = useSelector(
    (state: any) => state.role
  );
  const { notification } = useSelector((state: any) => state.mmym);

  const { userProfile } = useSelector((state: any) => state?.user);
  const [isBasicDiarySection, setIsBasicDiarySection] = useState(
    userProfile?.features?.includes("Basic Work Diary") || false // Safe fallback
  );

  useEffect(() => {
    setIsBasicDiarySection(
      userProfile?.features?.includes("Basic Work Diary") || false
    ); // Sync profile changes
  }, [userProfile]);

  const handleOpen = () => {
    setOpen(true);
    setTitle("Add Role");
    setSelectedRole("");
  };
  const handleClose = () => {
    setSelectedRole("");
    setOpen(false);
    setTitle("");
  };

  const handleDeleteClose = () => {
    setDeleteModelShow(false);
    setDeleteRoleData(null);
    setReassignRoleId("");
    dispatch(setNotificationAction({ message: [], severity: "error" }));
  };

  useEffect(() => {
    dispatch(getAllRoles());
    return () => {
      dispatch(setNotificationAction({ message: [], severity: "info" }));
    };
  }, [dispatch]);

  useEffect(() => {
    if (isAddRoleSuccess || isRoleResponse || isDeleteRoleSuccess || isReassignRoleSuccess) {
      dispatch(getAllRoles());
      dispatch(setAddRoleResponse(false));
      dispatch(updateRoleResponse(false));
      dispatch(setDeleteRoleResponse(false));
      dispatch(setReassignRoleResponse(false));
      dispatch(setNotificationAction({ message: [], severity: "error" }));

      handleClose();
      handleDeleteClose();
    }
  }, [dispatch, isAddRoleSuccess, isRoleResponse, isDeleteRoleSuccess, isReassignRoleSuccess]);

  const onClickEdit = (rolePermission: any) => {
    setOpen(true);
    setTitle("Edit Role");
    setSelectedRole(rolePermission);
  };

  const onClickDelete = (rolePermission: any) => {
    setDeleteRoleData(rolePermission);
    setDeleteModelShow(true);
  };

  const submitDeleteRole = () => {
    if (deleteRoleData) {
      dispatch(deleteRoleAction(deleteRoleData));
    }
  };

  const submitReassignRole = () => {
    if (deleteRoleData && reassignRoleId) {
      dispatch(
        reassignRoleAction({
          oldRoleId: deleteRoleData?.role_id || deleteRoleData?.id,
          replacement_role_id: reassignRoleId,
        })
      );
    }
  };

  // Other roles excluding the one being deleted
  const otherRoles = roles.filter(
    (r: any) => (r?.role_id || r?.id) !== (deleteRoleData?.role_id || deleteRoleData?.id)
  );

  const hasDeleteError = notification?.message && notification?.message?.length > 0;

  return (
    <>
     {deleteModelShow && <Popup
        open={deleteModelShow}
        title={hasDeleteError ? "Reassign Role" : "Delete Role"}
        onHide={handleDeleteClose}
        fullWidth={true}
        maxWidth={"xs"}
        aria-describedby="alert-dialog-slide-description"
        header={
          <>
            <img
              onClick={handleDeleteClose}
              src={closeIcon}
              className={classes.closeicons}
              alt="close"
            />
          </>
        }
        footer={
          <>
            <CustomButton variant="outlined" title="No" onClick={handleDeleteClose} />
            {hasDeleteError ? (
              <CustomButton
                title="Reassign Role"
                onClick={submitReassignRole}
                disabled={!reassignRoleId}
              />
            ) : (
              <CustomButton title="Yes" onClick={submitDeleteRole} />
            )}
          </>
        }
      >
        <DialogContent sx={{ padding: "0px" }}>
          <DialogContentText>
            <Alert sx={{ bgcolor: "#eeecef", fontSize: "16px" }} severity="warning">
              Are you sure you want to delete this role?
            </Alert>
            <Notification/>
            {hasDeleteError && otherRoles.length > 0 && (
              <Box sx={{ mt: 1, px: 2 }}>
                <Typography variant="body2" sx={{ fontWeight: 600, mb: 1 }}>
                  Select a role to reassign existing users:
                </Typography>
                <RadioGroup
                  value={reassignRoleId}
                  onChange={(e) => setReassignRoleId(e.target.value)}
                >
                  {otherRoles.map((role: any) => (
                    <FormControlLabel
                      key={role?.role_id || role?.id}
                      value={String(role?.role_id || role?.id)}
                      control={<Radio size="small" />}
                      label={role?.role || role?.name}
                    />
                  ))}
                </RadioGroup>
              </Box>
            )}
          </DialogContentText>
        </DialogContent>
      </Popup>}
     
       {open && (
        <ManageRole
          selectRole={selectedRole}
          open={open}
          onHide={handleClose}
          title={title}
        />)}
    
      <PageTitle
        title="User Role Management"
        button={!isBasicDiarySection && "Add Role"}
        onClick={handleOpen}
      />
      <Box
        sx={{
          width: "100%",
        }}
      >
        <Box
          // key={index}
          sx={{
            display: "flex",
            alignItems: "center",

            marginBottom: 0.5,
          }}
        >
          <PermissionsTable
            permissions={roles}
            onClickEdit={onClickEdit}
            onClickDelete={onClickDelete}
          />
        </Box>
      </Box>
    </>
  );
};
export default RoleDetails;
